import React from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./codeFilter.data.form";
import {
  InputDate,
  InputText,
  InputSelect,
  InputCheck,
  InputAutoComplete,
} from "@de-prado-dev/react-component-library";
import { CULTURES, CODE_STATUS } from "../../../../constants/index";

const CodeFilterForm = (props) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    onClean,
    onFilterArticle,
    onFilterLocation,
    viveros,
    onFilterBatch,
    onFilterVariety,
    onFilterSector,
  } = props;

  const renderListArticle = (item) => {
    return `${item.code}`;
  };

  const renderListLocation = (item) => {
    return `${item.name} (${item.vivero.name})`;
  };

  const renderListBatch = (item) => {
    return `${item.code}`;
  };

  const renderListVariety = (item) => {
    return `${item.name}`;
  };

  const renderListSector = (item) => {
    return `${item.name}`;
  };

  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <div className="accordion" id="codeFilter">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {t("forms.code.filter")}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#codeFilter"
            >
              <div className="accordion-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <div className="row">
                    <div className="col-12 col-md-3">
                      <Field
                        id="code"
                        className="form-control"
                        labelField={t("forms.code.labels.code")}
                        name="code"
                        placeholder=""
                        component={InputText}
                        fieldType="text"
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <Field
                        id="culture"
                        name="culture"
                        labelField={t("forms.code.labels.culture")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={CULTURES.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <Field
                        id="status"
                        name="status"
                        labelField={t("forms.code.labels.status")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={CODE_STATUS.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <Field
                        id="articleUuid"
                        className="form-control"
                        labelField={t("forms.workingPart.labels.article")}
                        name="articleUuid"
                        component={InputAutoComplete}
                        fieldType="text"
                        onSearch={onFilterArticle}
                        optionValue="uuid"
                        optionLabel="code"
                        textButtonReset={t("clear")}
                        renderItems={renderListArticle}
                      />
                    </div>

                    <div className="col-12 col-md-3">
                      <Field
                        id="viveroUuid"
                        name="viveroUuid"
                        labelField={t("forms.users.labels.vivero")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="uuid"
                        options={viveros.map((item) => ({
                          ...item,
                          label: item.name,
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <Field
                        id="batch"
                        className="form-control"
                        labelField={t("forms.workingPart.labels.batch")}
                        name="batch"
                        component={InputAutoComplete}
                        fieldType="text"
                        onSearch={onFilterBatch}
                        optionValue="uuid"
                        optionLabel="code"
                        textButtonReset={t("clear")}
                        renderItems={renderListBatch}
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <Field
                        id="varietyUuid"
                        className="form-control"
                        labelField={t("forms.workingPart.labels.variety")}
                        name="varietyUuid"
                        component={InputAutoComplete}
                        fieldType="text"
                        onSearch={onFilterVariety}
                        optionValue="uuid"
                        optionLabel="name"
                        textButtonReset={t("clear")}
                        renderItems={renderListVariety}
                      />
                    </div>

                    <div className="col-12 col-md-3">
                      <div className="row">
                        <div className="col-6">
                          <Field
                            id="locationUuid"
                            className="form-control"
                            labelField={t("forms.workingPart.labels.location")}
                            name="locationUuid"
                            component={InputAutoComplete}
                            fieldType="text"
                            onSearch={onFilterLocation}
                            optionValue="uuid"
                            optionLabel="name"
                            textButtonReset={t("clear")}
                            renderItems={renderListLocation}
                          />
                        </div>
                        <div className="col-6">
                          <Field
                            id="sectorUuid"
                            className="form-control"
                            labelField={t("forms.workingPart.labels.sector")}
                            name="sectorUuid"
                            component={InputAutoComplete}
                            fieldType="text"
                            onSearch={onFilterSector}
                            optionValue="uuid"
                            optionLabel="name"
                            textButtonReset={t("clear")}
                            renderItems={renderListSector}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary me-2"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg btn-secondary"
                        onClick={() => onClean(props.resetForm)}
                        title={t("cleanFilter")}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CodeFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const CodeFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "CodeFilterForm",
})(CodeFilterForm);

export default CodeFilterFormF;
